var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c(
        "app-browse",
        {
          attrs: {
            "button-bar-items": _vm.buttonBarItems,
            "context-menu-items": _vm.contextMenuItems,
            "controls-disabled": _vm.controlsDisabled,
            "data-source": _vm.dataSource,
            "search-enabled": _vm.searchEnabled,
            "selected-items": _vm.selectedItems,
            "url-query-params": "",
          },
          on: {
            "context-menu-item": function ($event) {
              _vm.selectedContextMenuItem = $event
            },
            convertToCreditNote: function ($event) {
              return _vm.convertToCreditNote()
            },
            createPublicLink: function ($event) {
              return _vm.createPublicLink($event)
            },
            downloadUbl: function ($event) {
              return _vm.downloadUbl($event)
            },
            printSale: function ($event) {
              return _vm.printSale($event)
            },
            downloadSale: function ($event) {
              return _vm.downloadSale($event)
            },
            shareSale: function ($event) {
              return _vm.shareSale($event)
            },
            processPayment: function ($event) {
              return _vm.processPayment($event)
            },
            saveAs: function ($event) {
              return _vm.saveAs($event)
            },
            sendAutoReminders: function ($event) {
              return _vm.sendAutoReminders()
            },
            sendPortal: function ($event) {
              return _vm.sendPortal($event)
            },
            sendReminder: function ($event) {
              return _vm.sendReminder($event)
            },
            sendSale: function ($event) {
              return _vm.sendSale($event)
            },
            sendSaleUbl: function ($event) {
              return _vm.sendSaleUbl($event)
            },
            createUblArchive: function ($event) {
              return _vm.createUblArchive()
            },
            createPdfArchive: function ($event) {
              return _vm.createPdfArchive()
            },
            openChangeComputedFriendlyIdModal: function ($event) {
              return _vm.openChangeComputedFriendlyIdModal($event)
            },
            state: function ($event) {
              _vm.browseState = $event
            },
            opencreateDagontvangstModal: function ($event) {
              _vm.createDagontvangstModal = true
            },
            checkCarpassStatus: function ($event) {
              return _vm.checkCarpassStatus($event)
            },
            addCarpassDescription: function ($event) {
              return _vm.addCarpassDescription($event)
            },
            addDeposit: function ($event) {
              return _vm.addDeposit($event)
            },
            "col-click-result": _vm.onColClick,
          },
        },
        [
          _vm._t("header", null, { slot: "header" }),
          _vm._t("extra-buttons", null, { slot: "extra-buttons" }),
          _vm._t("top", null, { slot: "top" }),
          _vm._t("bottom", null, { slot: "bottom" }),
        ],
        2
      ),
      _c(
        "w-modal",
        {
          attrs: { value: _vm.quickBankEditSale != null },
          on: {
            input: function ($event) {
              _vm.quickBankEditSale = null
            },
          },
        },
        [
          _vm.quickBankEditSale
            ? _c("app-bank-edit", {
                attrs: { sale: _vm.quickBankEditSale },
                on: {
                  cancel: function ($event) {
                    _vm.quickBankEditSale = null
                  },
                  update: function ($event) {
                    _vm.updateView(),
                      (_vm.quickBankEditSale = null),
                      _vm.cancelSelection()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.saleReminder,
            callback: function ($$v) {
              _vm.saleReminder = $$v
            },
            expression: "saleReminder",
          },
        },
        [
          _c("app-sale-reminder", {
            attrs: { "contact-id": _vm.selectedContactId },
            on: {
              cancel: function ($event) {
                _vm.saleReminder = false
              },
              close: function ($event) {
                return _vm.closeSaleReminder($event)
              },
            },
          }),
        ],
        1
      ),
      _vm.sendModal
        ? _c("app-send-sale", {
            attrs: { sale: _vm.toSendSale },
            on: {
              close: function ($event) {
                _vm.sendModal = false
              },
            },
          })
        : _vm._e(),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.publicLinkModal,
            callback: function ($$v) {
              _vm.publicLinkModal = $$v
            },
            expression: "publicLinkModal",
          },
        },
        [
          _c("app-public-link", {
            attrs: { link: _vm.publicLink },
            on: {
              cancel: function ($event) {
                return _vm.closePublicLink()
              },
            },
          }),
        ],
        1
      ),
      _vm.toSendSale
        ? _c(
            "w-modal",
            {
              model: {
                value: _vm.sendPortalModal,
                callback: function ($$v) {
                  _vm.sendPortalModal = $$v
                },
                expression: "sendPortalModal",
              },
            },
            [
              _vm.sendPortalModal
                ? _c("app-send-portal", {
                    attrs: {
                      contact: _vm.toSendSale.Contact,
                      link: _vm.clientPortalLink,
                      sale: _vm.toSendSale,
                    },
                    on: {
                      cancel: function ($event) {
                        _vm.sendPortalModal = false
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.createUblArchiveModal,
            callback: function ($$v) {
              _vm.createUblArchiveModal = $$v
            },
            expression: "createUblArchiveModal",
          },
        },
        [
          _vm.createUblArchiveModal
            ? _c("app-create-ubl-archive-modal", {
                attrs: { "selected-ids": _vm.ublArchiveSelectedIds },
                on: {
                  done: function ($event) {
                    return _vm.cancelSelection()
                  },
                  close: function ($event) {
                    _vm.createUblArchiveModal = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.createPdfArchiveModal,
            callback: function ($$v) {
              _vm.createPdfArchiveModal = $$v
            },
            expression: "createPdfArchiveModal",
          },
        },
        [
          _vm.createPdfArchiveModal
            ? _c("app-create-pdf-archive-modal", {
                attrs: { "browse-state": _vm.browseState },
                on: {
                  close: function ($event) {
                    _vm.createPdfArchiveModal = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.saveAsModal,
            callback: function ($$v) {
              _vm.saveAsModal = $$v
            },
            expression: "saveAsModal",
          },
        },
        [
          _vm.saveAsModal
            ? _c("app-save-as-modal", {
                attrs: { sales: _vm.selectedItems },
                on: {
                  close: function ($event) {
                    _vm.saveAsModal = false
                  },
                  refresh: function ($event) {
                    return _vm.updateView()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.autoSendReminders,
            callback: function ($$v) {
              _vm.autoSendReminders = $$v
            },
            expression: "autoSendReminders",
          },
        },
        [
          _c("app-reminder-auto-send", {
            on: {
              close: function ($event) {
                _vm.autoSendReminders = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          staticClass: "w100",
          attrs: {
            value: _vm.$route.path != "/sales",
            "escape-close": "",
            "full-height": "",
          },
        },
        [
          _c("router-view", {
            key: _vm.$route.path,
            on: {
              "parent-should-refresh": function ($event) {
                return _vm.updateView()
              },
              "clear-selection": _vm.clearSelection,
            },
          }),
        ],
        1
      ),
      _c("app-sale-print-select-layout-modal", {
        attrs: { value: _vm.combinedSalePrintingLayoutId },
        on: {
          print: function ($event) {
            return _vm.printSale()
          },
          input: function ($event) {
            _vm.combinedSalePrintingLayoutId = $event
          },
          close: function ($event) {
            ;(_vm.showCombinedSalePrintingLayoutSelect = false),
              (_vm.combinedSalePrintingLayoutId = null)
          },
        },
      }),
      _c("app-combined-sale-spinner-modal", {
        attrs: { value: _vm.isPrintingCombinedSale },
      }),
      _c(
        "w-modal",
        { attrs: { value: _vm.createDagontvangstModal } },
        [
          _c("app-create-dagontvangst-modal", {
            on: {
              close: function ($event) {
                _vm.createDagontvangstModal = false
              },
              refresh: function ($event) {
                return _vm.updateView()
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.peppolModalOpen } },
        [
          _vm.peppolModalOpen
            ? _c("app-send-via-peppol-modal", {
                attrs: { sale: _vm.toSendSale },
                on: {
                  close: function ($event) {
                    _vm.peppolModalOpen = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.changeFriendlyIdModalOpen } },
        [
          _vm.changeFriendlyIdModalOpen && _vm.toSendSale
            ? _c("app-change-friendly-id-modal", {
                attrs: { sale: _vm.toSendSale },
                on: {
                  close: function ($event) {
                    _vm.changeFriendlyIdModalOpen = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.deletedSalesModal } },
        [
          _vm.deletedSalesModal
            ? _c("app-deleted-sales-browse", {
                on: {
                  close: function ($event) {
                    _vm.deletedSalesModal = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toSendViaSendcloudSale != null } },
        [
          _vm.toSendViaSendcloudSale
            ? _c("app-create-sendcloud-parcel", {
                attrs: { sale: _vm.toSendViaSendcloudSale },
                on: {
                  close: function ($event) {
                    _vm.toSendViaSendcloudSale = null
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.sendcloudBrowseSale != null } },
        [
          _vm.sendcloudBrowseSale
            ? _c("app-sale-send-cloud-parcels", {
                attrs: { sale: _vm.sendcloudBrowseSale },
                on: {
                  close: function ($event) {
                    _vm.sendcloudBrowseSale = null
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("app-carpass-input-modal", {
        attrs: { state: _vm.carpassInputModalState },
      }),
      _vm.carpassEditObservationDescriptionSale
        ? _c("app-carpass-observation-description-modal", {
            attrs: { sale: _vm.carpassEditObservationDescriptionSale },
            on: {
              close: function ($event) {
                _vm.carpassEditObservationDescriptionSale = null
              },
            },
          })
        : _vm._e(),
      _vm.addDepositModalSale
        ? _c("app-add-deposit-modal", {
            attrs: { sale: _vm.addDepositModalSale },
            on: {
              close: function ($event) {
                _vm.addDepositModalSale = null
              },
              refresh: function ($event) {
                return _vm.updateView()
              },
            },
          })
        : _vm._e(),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.fillLedgerAccountsModalOpen,
            callback: function ($$v) {
              _vm.fillLedgerAccountsModalOpen = $$v
            },
            expression: "fillLedgerAccountsModalOpen",
          },
        },
        [
          _vm.fillLedgerAccountsModalOpen
            ? _c("app-fill-ledger-accounts-modal", {
                attrs: { sales: _vm.selectedItems },
                on: {
                  close: function ($event) {
                    _vm.fillLedgerAccountsModalOpen = false
                  },
                  refresh: function ($event) {
                    return _vm.updateView()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.editDeliveryDateModalSale
        ? _c("app-sale-edit-delivery-date-modal", {
            attrs: { sale: _vm.editDeliveryDateModalSale },
            on: {
              close: function ($event) {
                _vm.editDeliveryDateModalSale = null
              },
            },
          })
        : _vm._e(),
      _vm.saveToModalOpen
        ? _c("app-sale-save-to-modal", {
            attrs: {
              "contact-group-id": 1,
              "selected-items": _vm.selectedItems,
            },
            on: {
              close: function ($event) {
                _vm.saveToModalOpen = false
              },
            },
          })
        : _vm._e(),
      _vm.convertToCreditNoteModal
        ? _c("app-convert-to-credit-note-modal", {
            attrs: { sales: _vm.selectedItems },
            on: {
              close: function ($event) {
                _vm.convertToCreditNoteModal = false
              },
              confirm: function ($event) {
                return _vm.doConvertToCreditNote($event)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }